/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { AppBar } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import SubmissionPreviewActions from './SubmissionPreviewActions';

const useStyles = makeStyles(theme => ({
  bottomBar: {
    padding: '.25rem 1.5rem',
    bottom: 0,
    textAlign: 'right',
    backgroundColor: theme.palette.contrastBackground,
    opacity: 0.95,
    [theme.breakpoints.up('xl2')]: {
      paddingLeft: '3.5%',
      paddingRight: '3.5%',
    },
  },
}));

export default function SubmissionPreviewFooter({ className, buttonsConfig }) {
  const classes = useStyles();

  return (
    <AppBar component="div" position="sticky" elevation={0} className={clsx(classes.bottomBar, className)}>
      <SubmissionPreviewActions buttonsConfig={buttonsConfig} />
    </AppBar>
  );
}
